<!-- <template>
  <Navbar />
  <body>
    <GoogleMap api-key="AIzaSyD_zYm-FwM1I5pRHmHm0PwsntB9g-DiaRo" style="width: 100%; height: 500px" :center="center" :zoom="15" >
    <Marker :options="{ position: center }" />
  </GoogleMap>
  </body>
</template>

<script>
import Navbar from "@/components/navbar_web.vue";
import { defineComponent } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";

export default defineComponent({
  components: { GoogleMap, Marker ,Navbar},
  setup() {
    const center = { lat: 14.348360, lng: 100.576271};

    return { center };
  },
});
</script> -->

<template>
  <Navbar style="z-index: 3" />

  <body>
    <div style="height:100vh; width:100vw">
      <!-- <div   style="position: absolute; left: 150px; top: 100px; z-index: 1;">
      <div class="text-end pe-5" style="padding-top: 250px;">   <button type="button" class="btn btn-info   rounded-circle btn-lg" style="background-color: #55acee;"><font-awesome-icon :icon="['fas', 'up-right-and-down-left-from-center']" style="font-size: 14px;color: #fff;"/></button></div>
    </div> -->
      <div v-if="status_box == true" style="position: absolute; left: 35px; top: 180px; z-index: 1;">
        <div class="card shadow-sm bg-light" style="width: 18rem;">
          <div class="card-body ">
            <h5 class="card-title" style="font-weight: 700;color: #344767;">สถานะการทำงาน</h5>
            <h6 class="card-subtitle mb-2 text-muted">สัญลักษณ์แสดงสถานะการทำงาน</h6>
            <ul class="list-group list-group-flush ">
              <li class="list-group-item bg-light">
  <div class="row">
    <div class="col-7">สถานะไม่ทำงาน</div>
    <div class="col-5 text-end">
      <span style="display:inline-block; width:14px; height:14px; border-radius:50%; background:#9E9E9E; vertical-align:middle;"></span>
    </div>
  </div>
</li>
<li class="list-group-item bg-light">
  <div class="row">
    <div class="col-7">สถานะทำงานปกติ</div>
    <div class="col-5 text-end">
      <span style="display:inline-block; width:14px; height:14px; border-radius:50%; background:#4CAF50; vertical-align:middle;"></span>
    </div>
  </div>
</li>
<li class="list-group-item bg-light">
  <div class="row">
    <div class="col-7">สถานะผิดปกติ</div>
    <div class="col-5 text-end">
      <span style="display:inline-block; width:14px; height:14px; border-radius:50%; background:#FFC107; vertical-align:middle;"></span>
    </div>
  </div>
</li>
            </ul>
            <a href="#" class="card-link">รายงาน</a>
          </div>
        </div>
      </div>
      <div v-if="status_box == true" style="position: absolute; left: 12px; top: 160px; z-index: 1;">
        <button type="button" class="btn btn-info rounded-circle btn-lg" style="background-color: #55acee;"
          @click="status_box=false">
          <font-awesome-icon :icon="['fas', 'down-left-and-up-right-to-center']" style="font-size: 14px;color: #fff;" />
        </button>
      </div>

      <div v-else-if="status_box == false" style="position: absolute; right: 10px; bottom: 500px; z-index: 1;">
        <div class="text-end " style="padding-top: 250px;">
          <button type="button" class="btn btn-info rounded-circle btn-lg" style="background-color: #55acee;"
            @click="status_box=true">
            <font-awesome-icon :icon="['fas', 'up-right-and-down-left-from-center']"
              style="font-size: 14px;color: #fff;" />
          </button>
        </div>
      </div>

      <!-- <div style="position: absolute; right: 10px; bottom: 440px; z-index: 1;">
        <div class="text-end " style="padding-top: 250px;">
          <button type="button" class="btn btn-info rounded-circle btn-lg" style="background-color: #55acee;"  @click="status_box=true">
            <font-awesome-icon :icon="['fas', 'up-right-and-down-left-from-center']"
              style="font-size: 14px;color: #fff;" />
          </button>
        </div>
      </div> -->
      

      <!-- <div style="position: absolute; right: 4cqw; top: 100px; z-index: 1;">
        <div style="font-size: 1.5cqw;color: #000000;text-shadow: 2px 1px #34476760;">โครงการสถานีสูบน้ำด้วยไฟฟ้า
          สถานีสูบน้ำ P.5</div>
        <div class="text-end" style="font-size: 18px;color: #555555;">โครงการสถานีสูบน้ำด้วยไฟฟ้า</div>
      </div> -->

       <!-- กล่องค้นหาสถานี (อยู่บนช่องเลือกสถานะ) -->
       <div style="position: absolute; right: 4cqw; top: 70px; z-index: 1;">
         <div class="text-end" style="font-size: 18px;color: #555555;">ค้นหาสถานี</div>
       </div>
       <div style="position: absolute; right: 4cqw; top: 11cqh; z-index: 1;">
         <div class="position-relative" style="width: 280px;">
           <input
             v-model.trim="searchText"
             type="search"
             class="form-control rounded border-dark shadow-lg pe-4"
             placeholder="พิมพ์ชื่อสถานี..."
             style="width: 280px;height: 32px;font-size: 14px;"
           />
           <span v-if="searchText" class="position-absolute"
                 style="right: 8px; top: 50%; transform: translateY(-50%); cursor:pointer; color:#888;"
                 @click="searchText=''" title="ล้างคำค้น">✕</span>
         </div>
       </div>

       <div style="position: absolute; right: 4cqw; top: 138px; z-index: 1;">
        <div class="text-end" style="font-size: 18px;color: #555555;">เลือกสถานะการทำงาน</div>
      </div>

      <!-- <div style="position: absolute; right: 4cqw; top: 18.5cqh; z-index: 1;">
            <select v-model="selected" style="width: 280px;height: 25px;" class="rounded  border-dark shadow-lg">
              <option disabled value="">เลือกสถานะการทำงาน</option>
              <option>สถานะไม่ทำงาน</option>
              <option>สถานะทำงานปกติ</option>
              <option>สถานะผิดปกติ</option>
            </select>
          </div> -->
      <div style="position: absolute; right: 4cqw; top: 18cqh; z-index: 1;">
        <select v-model="selectedStatus" style="width: 280px;height: 25px;"
          class="rounded border-dark shadow-lg">
          <option value="">ทั้งหมด</option>
          <option value="0">สถานะไม่ทำงาน</option>
          <option value="1">สถานะทำงานปกติ</option>
          <option value="2">สถานะผิดปกติ</option>
        </select>
      </div>


<l-map v-if="markerLatLng"
       ref="map"
       :center="markerLatLng"
       v-model:zoom="zoom"
       style="position: absolute; z-index: 0;">
        <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base" name="OpenStreetMap">
        </l-tile-layer>
        <!-- <l-marker :lat-lng=" [14.348360, 100.576271]" >
        <l-popup>
          <br><strong>Location Name: </strong><br><strong>Date: </strong><br><button style="margin:5% 0% 0% 35%;" @click="addStops(marker)">Add</button>
        </l-popup>
      </l-marker> -->

        <l-marker
          v-for="(group, gIndex) in groupedMarkers"
          :key="'g-'+gIndex"
          :lat-lng="group.latLng"
          @click="onGroupClick(group)"
        >
          <l-icon class-name="someExtraClass">

            <!-- Marker = วงกลมพื้นเขียว/แดง พร้อม icon controls สีขาว
                 ถ้าใน group มีหลายสถานี → แสดง badge จำนวน -->
            <div
              class="status-marker myDIV position-relative"
              :class="{
                'is-online'  : group.status == 1,
                'is-offline' : group.status == 0,
                'is-warning' : group.status == 2
              }"
              type="button"
              :title="group.stations.length > 1 ? group.stations.length + ' สถานีในตำแหน่งเดียวกัน' : group.stations[0].name"
            >
              <img src="../assets/controls-icon.svg" alt="device" class="status-marker__icon" />
              <span v-if="group.stations.length > 1" class="status-marker__badge">
                {{ group.stations.length }}
              </span>
            </div>

            <!-- ป้ายชื่อตอน hover -->
            <div class="hide border rounded-3" style=" font-size: 20px;">
              <div class="text-center" style="font-size: 14px;">ชื่อสถานี</div>
              <div class="text-center" style="font-size: 14px;">
                <template v-if="group.stations.length === 1">{{ group.stations[0].name }}</template>
                <template v-else>{{ group.stations.length }} สถานี</template>
              </div>
            </div>

          </l-icon>
          <l-popup
            :options="{ closeOnClick: false, autoClose: false, closeButton: false, keepInView: true }"
          >
            <div @click.stop>
              <!-- ขั้นที่ 1: เลือกสถานีก่อน (ถ้ามีหลายสถานีในจุดเดียวกัน) -->
              <div v-if="group.stations.length > 1 && !selectedFromGroup[groupKey(group)]"
                   class="col" style="min-width:180px;">
                <div class="mb-1" style="font-size:13px;font-weight:600;color:#333;">
                  <font-awesome-icon :icon="['fas', 'location-dot']" />
                  {{ group.stations.length }} สถานีในจุดนี้
                </div>
                <div v-for="st in group.stations" :key="st.id"
                     class="rounded-3 p-1 mt-1 shadow"
                     style="background-color:#eeeeeec9; cursor:pointer; font-size:13px;"
                     @click.stop.prevent="pickStationFromGroup(group, st)"
                >
                  <span class="me-1"
                        :class="{
                          'badge bg-success': st.status == 1,
                          'badge bg-secondary': st.status == 0,
                          'badge bg-warning text-dark': st.status == 2
                        }">
                    &nbsp;
                  </span>
                  <span style="font-weight:600;">{{ st.name }}</span>
                </div>
              </div>

              <!-- ขั้นที่ 2: ตัวเลือก หน้าหลัก / กราฟ ของสถานีที่ถูกเลือก -->
              <div v-else class="col">
                <!-- back ถ้ามาจาก group ที่มีหลายสถานี -->
                <div v-if="group.stations.length > 1"
                     class="mb-1 text-muted" style="font-size:11px;cursor:pointer;"
                     @click.stop.prevent="backToGroupList(group)">
                  ← กลับ
                </div>
                <div style="font-size:13px;font-weight:600;color:#333;" class="mb-1">
                  {{ getActiveStation(group).name }}
                </div>

                <router-link
                  style="text-decoration: none; color: inherit;"
                  :to="`/inside?name=${getActiveStation(group).name}&id=${getActiveStation(group).id}`"
                >
                  <div type="button" class="rounded-5 p-1 shadow" style="background-color: #eeeeeec9;">
                    <button type="button" class="btn p-1 rounded-5 btn-lg" style="background-color: #1a94f869;">
                      <font-awesome-icon :icon="['fas', 'house']" />
                    </button>
                    <span style="font-size: 14px;font-weight: 700;"> หน้าหลัก</span>
                  </div>
                </router-link>
                <!-- <div type="button" class="rounded-5 p-1 mt-1 shadow"
                     data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                     style="background-color: #eeeeeec9;"
                     @click.stop>
                  <button type="button" class="btn p-1 rounded-5 btn-lg" style="background-color: #1a94f869;">
                    <font-awesome-icon :icon="['fas', 'chart-simple']" />
                  </button>
                  <span style="font-size: 14px;font-weight: 700;"> กราฟ</span>
                </div> -->
              </div>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </div>
  </body>

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered  modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            <font-awesome-icon :icon="['fas', 'chart-simple']" /> กราฟแสดงผล</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Chart_Consumption />
          <div>
          </div>
          <Log_Consumption />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import "leaflet/dist/leaflet.css";
  import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
  } from "@vue-leaflet/vue-leaflet";

  import Navbar from "@/components/navbar_web.vue";
  import Chart_Consumption from "@/components/charts/consumpsion_chart.vue";
  import Log_Consumption from "@/components/charts/consumption_log.vue";
  export default {
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LIcon,
      Navbar,
      Chart_Consumption,
      Log_Consumption,
      LPopup
    },
    data() {
      return {
        mapCenter: [],
        s: 'ss',
        allStations: [],
        selectedStatus: '',
        searchText: '',
        // เก็บสถานีที่ผู้ใช้เลือกจาก group (key = group key, value = station)
        selectedFromGroup: {},
        status_box: true,
        items: [
          // {
          //   latLng: [14.348360, 100.576271],
          //   icon: "../assets/logo.png",
          //   name: "สถานีสูบน้ำโซน 2 ตอน 1"
          // }, {
          //   latLng: [14.148360, 100.576271],
          //   icon: "../assets/logo.png",
          //   name: "สถานีสูบน้ำโซน 2 ตอน 2 สถานีสูบน้ำ"
          // }, {
          //   latLng: [14.438360, 100.176271],
          //   icon: "../assets/logo.png",
          //   name: "สถานีสูบน้ำโซน 2 ตอน 3 สถานีสูบน้ำ"
          // },

          // {
          //   latLng: [14.638360, 100.776271],
          //   icon: "../assets/logo.png",
          //   name: "สถานีสูบน้ำโซน 2 ตอน 3 สถานีสูบน้ำ"
          // },

        ],
        zoom: 7,
  markerLatLng: null,
        iconSize: 64,
        staticAnchor: [16, 1],

      };
    },
    computed: {
      dynamicSize() {
        return [this.iconSize, this.iconSize * 1.15];
      },
      dynamicAnchor() {
        return [this.iconSize / 2, this.iconSize * 1.15];
      },
      // กรองสถานีตาม searchText + selectedStatus
      filteredStations() {
        const q = (this.searchText || '').trim().toLowerCase();
        const list = (this.allStations || []).filter(s => {
          if (!s) return false;
          // กรองตามสถานะ
          if (this.selectedStatus !== '' && Number(s.status) !== parseInt(this.selectedStatus)) {
            return false;
          }
          // กรองตามคำค้น (ชื่อ / description / id)
          if (q) {
            const fields = [s.name, s.description, s.id]
              .filter(v => v !== undefined && v !== null)
              .map(v => String(v).toLowerCase());
            if (!fields.some(f => f.includes(q))) return false;
          }
          return true;
        });
        return list;
      },
      // จัดกลุ่มสถานีที่อยู่ในพิกัดเดียวกัน (lat,lng ปัดเศษ 5 ตำแหน่ง)
      groupedMarkers() {
        const groups = {};
        (this.filteredStations || []).forEach(s => {
          if (!s || !Array.isArray(s.latLng)) return;
          const lat = Number(s.latLng[0]);
          const lng = Number(s.latLng[1]);
          if (isNaN(lat) || isNaN(lng)) return;
          const key = `${lat.toFixed(5)},${lng.toFixed(5)}`;
          if (!groups[key]) {
            groups[key] = {
              key,
              latLng: [lat, lng],
              stations: [],
              status: s.status
            };
          }
          groups[key].stations.push(s);
          // ใช้สถานะที่แย่ที่สุดของกลุ่มแสดงสีหมุด: 0 (offline) > 2 (warning) > 1 (online)
          const cur = Number(groups[key].status);
          const incoming = Number(s.status);
          const rank = (v) => (v === 0 ? 3 : (v === 2 ? 2 : (v === 1 ? 1 : 0)));
          if (rank(incoming) > rank(cur)) groups[key].status = s.status;
        });
        return Object.values(groups);
      }
    },
    methods: {
  

      setMapCenterFromMarkers() {
        const lats = this.items.map(loc => loc.latLng[0])
        const lngs = this.items.map(loc => loc.latLng[1])

        const avgLat = lats.reduce((a, b) => a + b, 0) / lats.length
        const avgLng = lngs.reduce((a, b) => a + b, 0) / lngs.length
        console.log("this.items");
        console.log(this.items );

        this.markerLatLng = [avgLat, avgLng]
        console.log("this.markerLatLng");
        console.log(this.markerLatLng);
      },

      async fetchPageMap() {
        try {
          const token = localStorage.getItem('accessToken');
          const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/page/plan`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          console.log('Page Map Data:', response.data.data);
          const convertedData = response.data.data.map(item => ({
            ...item,
            latLng: [item.Latitude, item.Longitude],
            Latitude: undefined,
            Longitude: undefined,
            icon: "../assets/logo.png"
          }));

          // ลบ key ที่ไม่ต้องการ
          convertedData.forEach(item => {
            delete item.Latitude;
            delete item.Longitude;
          });
          this.items = convertedData;
          this.allStations = this.items;
          if (this.items.length > 0) {
            // this.markerLatLng = [14.348360, 100.576271];
              this.setMapCenterFromMarkers()
          } else {
            this.markerLatLng = [14.348360, 100.576271];
                    //  this.setMapCenterFromMarkers()
          }
        } catch (error) {
          console.error('Error fetching page map:', error);
        }
      },

      // เก็บไว้เผื่อยังถูกเรียกจากที่อื่น (ตอนนี้ filter ด้วย computed แทน)
      filterStations() { /* no-op: filtering moved to computed filteredStations */ },

      // === กลุ่ม marker (lat/lon ใกล้กัน) ===
      groupKey(group) {
        return group?.key || '';
      },
      onGroupClick(group) {
        if (!group) return;
        // ถ้ามีสถานีเดียวให้เลือกสถานีนั้นทันที
        if (group.stations.length === 1) {
          this.selectedFromGroup = {
            ...this.selectedFromGroup,
            [group.key]: group.stations[0]
          };
        } else {
          // หลายสถานี → reset เพื่อแสดงรายการก่อน
          this.selectedFromGroup = {
            ...this.selectedFromGroup,
            [group.key]: null
          };
        }
      },
      pickStationFromGroup(group, station) {
        if (!group || !station) return;
        // ใช้ spread เพื่อให้ Vue track การเปลี่ยนแปลงและ re-render popup ทัน
        this.selectedFromGroup = {
          ...this.selectedFromGroup,
          [group.key]: station
        };
      },
      backToGroupList(group) {
        if (!group) return;
        this.selectedFromGroup = {
          ...this.selectedFromGroup,
          [group.key]: null
        };
      },
      getActiveStation(group) {
        if (!group) return { name: '', id: '' };
        if (group.stations.length === 1) return group.stations[0];
        const sel = this.selectedFromGroup[group.key];
        return sel || group.stations[0];
      },

      getLatLng(i) {
        return this.items[i]["latLng"];
      }
    },
    created() {
      this.fetchPageMap();
    },
    mounted() {
          //  this.fetchPageMap();
      // this.setMapCenterFromMarkers()
    }
  };
</script>

<style scoped>
  @import '../components/style/hover.css';
  @import '../components/style/round_bt.css';

  .leaflet-popup-content-wrapper,
  .leaflet-popup-tip {
    padding-left: 80px;
    margin-bottom: -20px;
    background-color: #00000000;
    box-shadow: none !important;
  }

  .someExtraClass {
    padding: 10px;
  }

  .red {
    background-color: red;
    position: absolute;
  }

  .box {
    width: 100px;
    height: 100px;
    color: white;
    text-align: center;
  }

  .modal-xl {
    min-width: 90dvw;
  }

  /* Marker icon = วงกลมเล็ก minimal พร้อม icon controls */
  .status-marker {
    width: 31px;
    height: 31px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    transition: transform 0.15s ease-in-out;
  }
  .status-marker:hover {
    transform: scale(1.12);
  }
  .status-marker__icon {
    width: 16px;
    height: 16px;
    pointer-events: none;
    /* บังคับ stroke svg ให้เป็นสีขาว */
    filter: brightness(0) invert(1);
  }
  .status-marker.is-online {
    background-color: #4DD3A4;   /* มินต์ = online */
  }
  .status-marker.is-offline {
    background-color: #9aa0a6;   /* เทา = offline */
  }
  .status-marker.is-warning {
    background-color: #ffc107;   /* เหลือง = warning */
  }
  /* badge แสดงจำนวนสถานีในกลุ่ม (พิกัดเดียวกัน) */
  .status-marker__badge {
    position: absolute;
    top: -6px;
    right: -6px;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    background: #ff5252;
    color: #fff;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid #fff;
    line-height: 1;
  }
</style>